import React, { FunctionComponent, ReactNode } from "react";

import NavBarRedesignSelectionLine from "./nav_bar_redesign_selection_line";

export type Props = {
  selected: boolean
  children: ReactNode
};

// Wraps one of the top nav's right-side icon buttons and draws the selection line under it while it is
// selected. The line cannot sit inside the button itself: Nova's IconButton clips anything drawn outside
// its own box (see .NavBarRedesign-iconSlot in nav_bar_redesign.css).
const NavBarRedesignIconSlot: FunctionComponent<Props> = ({ selected, children }) => {
  return <span className="NavBarRedesign-iconSlot">
    {children}
    {selected && <NavBarRedesignSelectionLine/>}
  </span>;
};

export default NavBarRedesignIconSlot;
